<div class="at-wrapper">

  <!-- Page header -->
  <div class="at-page-header">
    <div>
      <h1 class="at-title">Activity Tracker</h1>
      <p class="at-subtitle">A global, filterable view of who created, updated, or deleted content across the CMS.</p>
    </div>
  </div>

  <!-- Filter panel -->
  <div class="at-filters">
    <div class="at-filter-group">
      <label class="at-filter-label">User</label>
      <p-autoComplete
        [(ngModel)]="selectedUser"
        [suggestions]="userSuggestions"
        (completeMethod)="searchUsers($event)"
        (onSelect)="applyFilters()"
        (onClear)="applyFilters()"
        field="name"
        placeholder="All Users"
        [dropdown]="false"
        [forceSelection]="true"
        [showClear]="true">
        <ng-template let-user pTemplate="item">
          {{ user.name || user.email }}
        </ng-template>
      </p-autoComplete>
    </div>

    <div class="at-filter-group">
      <label class="at-filter-label">Entity Type</label>
      <p-dropdown
        [options]="entityTypeOptions"
        [(ngModel)]="selectedEntityType"
        optionLabel="label"
        optionValue="value"
        placeholder="All Entity Types"
        [showClear]="true"
        [filter]="true"
        filterBy="label"
        (onChange)="applyFilters()">
      </p-dropdown>
    </div>

    <div class="at-filter-group">
      <label class="at-filter-label">Action</label>
      <p-dropdown
        [options]="actionOptions"
        [(ngModel)]="selectedAction"
        optionLabel="label"
        optionValue="value"
        placeholder="All Actions"
        [showClear]="true"
        (onChange)="applyFilters()">
      </p-dropdown>
    </div>

    <div class="at-filter-group">
      <label class="at-filter-label">Date Range</label>
      <p-calendar
        [(ngModel)]="dateRange"
        selectionMode="range"
        [showIcon]="true"
        [readonlyInput]="true"
        placeholder="All Time"
        (onSelect)="applyFilters()"
        (onClearClick)="applyFilters()">
      </p-calendar>
    </div>

    <button
      *ngIf="hasFilters"
      pButton
      pRipple
      type="button"
      label="Clear filters"
      class="p-button-outlined p-button-sm at-clear-btn"
      (click)="clearFilters()">
    </button>
  </div>

  <!-- Table -->
  <app-ag-grid-table
    *ngIf="columnDefs.length"
    [entity]="entity"
    [columnDefs]="columnDefs"
    [tableParams]="tableParams"
    [fullEditModeEnabled]="false"
    rowSelection="none">
  </app-ag-grid-table>

</div>
